import Parse from 'parse'

const state = {
  tourism: null
}

const mutations = {
  setTourism (state, tourism) {
    state.tourism = tourism
  }
}

const actions = {
  async checkPoint ({ commit, dispatch, rootGetters }) {
    commit('setTourism', null)
    await dispatch('gps/setPosition', null, { root: true })
    const geoPoint = rootGetters['gps/point']
    const result = await Parse.Cloud.run('tourismPointCheck', {
      geoPoint: geoPoint
    })

    if (result.status === 'pointCheckNotAllowed') {
      await dispatch('event/fetchPlaying', null, { root: true })
      return result.status
    }
    commit('setTourism', result.tourism)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
